import { chunk } from 'lodash'
import { validation } from 'utils'
import * as Yup from 'yup'
import { setProgress } from 'features/export_import/importExportSlice'
import {
    convertBooleanValue,
    LIMITED_NUMBER_OF_UPLOADED_ITEMS,
} from 'features/export_import/utils'
import { showErrorNotification } from 'features/notifications/notificationsSlice'
// @ts-ignore
import SampleFile from 'features/export_import/sample_files/sample_poster.xlsx'
import {
    ImportDataFormProps, MappedField, SampleDataType
} from 'features/export_import/types'
import { importPosters } from './graphql/mutation'

export const mappedFields: MappedField[] = [
    { field: 'externalId', label: 'ID', isRequired: true },
    { field: 'title', label: 'Title', isRequired: true },
    { field: 'abstract', label: 'Abstract' },
    { field: 'authorNames', label: 'Author name' },
    { field: 'authorEmail', label: 'Author email' },
    { field: 'videoUrl', label: 'Video url' },
    { field: 'enableChat', label: 'Enable chat' },
    { field: 'published', label: 'Published' },
    { field: 'locationType', label: 'Location type' },
]

export const sampleData: SampleDataType[] = [
    { header: 'ID', value: 'Unique ID' },
    { header: 'Title', value: 'title' },
    {
        header: 'Abstract',
        value: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit,'
            + ' sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.'
    },
    { header: 'Author name', value: 'author name' },
    { header: 'Author email', value: 'author@email.com' },
    { header: 'Video url', value: 'https://www.youtube.com/embed/XKwmoLKUU0s' },
    { header: 'Enable chat', value: '1 or 0' },
    { header: 'Published', value: '1 or 0' },
]

export const validationSchema = Yup.array().of(
    Yup.object().shape({
        externalId: validation.excelExternalId,
        title: Yup.string().required(),
        abstract: Yup.string(),
        authorEmail: Yup.string().email(),
        videoUrl: validation.videoEmbeddedUrl,
        enableChat: validation.excelBoolean,
        published: validation.excelBoolean,
        locationType: Yup.string().oneOf(
            ['', 'HYBRID', 'IN_PERSON', 'VIRTUAL'], 'The location type must be VIRTUAL or IN_PERSON or HYBRID'
        ),
    })
)

export const importProps: Omit<ImportDataFormProps, 'onSubmit'> = {
    mappedFields,
    sampleData,
    sampleFile: SampleFile,
    validationSchema,
}

export const handleSubmit = async (posterSpace, data, dispatch, callback) => {
    const submittedData = data.map((e) => ({
        ...e,
        enableChat: convertBooleanValue(e.enableChat),
        published: convertBooleanValue(e.published),
        locationType: e.locationType || null
    }))

    let completed = 0
    let errorItems = []
    const chunked_data = chunk(submittedData, LIMITED_NUMBER_OF_UPLOADED_ITEMS)
    // eslint-disable-next-line no-restricted-syntax
    for (const _data of chunked_data) {
        // eslint-disable-next-line no-await-in-loop
        const response = await importPosters(posterSpace, _data)
        if (response.errors.length) {
            return dispatch(showErrorNotification(response.errors))
        }
        const importResult = response.data.importPoster
        completed += LIMITED_NUMBER_OF_UPLOADED_ITEMS
        errorItems = [...errorItems, ...importResult.errorItems.map((e) => e.id)]
        dispatch(
            setProgress({
                completed: Math.min(completed, submittedData.length),
                errorItems,
            })
        )
    }
    callback?.()
}
